import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-assist.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessAssist';

class AgentBookingMailInprocessAssistCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessAssist implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessAssistCtrl];
}

export default MODULE_NAME;
